import axios from "axios";

export const http = axios.create({
    baseURL: "//" + process.env.IO_FE_API_HOST,
    withCredentials: true,
});

http.interceptors.response.use(
    (res) => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        res.data = res.data.data;
        return res;
    },
    (error) => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        if (error.response?.status === 423) {
            // redirect to maintenance page
            window.location.href = "/maintenance";
        }

        // Do something with response error
        return Promise.reject(error);
    },
);
